export const initalData={
    data:{}
}